import { ApiModel, ApiResource } from 'lib/interfaces/api';
import { Iso8601DateString } from 'lib/types';

export enum InvoiceStatus {
  InProgress = 'in_progress',
  Draft = 'draft',
  Open = 'open',
  Paid = 'paid',
  Uncollectible = 'uncollectible',
  Void = 'void',
  Canceled = 'canceled',
}

export interface Commitment {
  id: string;
  'initial-amount-cents': number;
  'used-amount-cents-on-pending-invoices': number;
  'total-used-amount-cents-including-pending-invoices': number;
  'total-used-amount-cents-excluding-pending-invoices': number;
  'remaining-amount-cents-excluding-pending-invoices': number;
  'remaining-amount-cents-including-pending-invoices': number;
  'commitment-period-start-at': string;
  'commitment-period-end-at': string;
}

export interface InvoiceMeta {
  commitments: Commitment[];
}

export interface InvoiceAttributes {
  status: InvoiceStatus;
  'period-start-at': string;
  'period-end-at': string;
  'source-data-updated-as-of'?: Iso8601DateString | null;
  'tax-amount-cents'?: number;
  'subtotal-amount-cents'?: number;
  'total-amount-cents'?: number;
  'pdf-url'?: string;
  'stripe-invoice-id': string;
  'line-items'?: InvoiceLineItemAttributes[];
}

export interface InvoiceLineItemAttributes {
  'source-id': string;
  description: string;
  'flat-amount-cents'?: number;
  'unit-amount-cents'?: number;
  'unit-quantity'?: number;
  amount?: number;
  hidden?: boolean;
}

export interface InvoiceRelationships {}

export type Invoice = ApiResource<InvoiceAttributes, InvoiceRelationships, ApiModel.Invoice>;
